import React from "react";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import RespondentTerminalPage from "../components/ending/RespondentTerminalPage";
import environment from "../environments/environment.json";

// showOffersPromo controls the "explore more offers" panel below - defaults to false for now
// so it's hidden until we're ready to turn it on (no route/query-param wiring yet, just the prop).
const SuccessV2 = ({ showOffersPromo = false }) => {
  return (
    <RespondentTerminalPage
      variant="success"
      message="Thank you for your participation! Your response has been recorded successfully."
    >
      {showOffersPromo && (
        <>
          <hr className="rf-ending-rise-delay-1 mt-5 border-t border-gray-200" />
          <div className="rf-ending-rise-delay-2 mt-2 rounded-2xl bg-gray-50 px-5 py-2 text-center">
            <p className="text-sm text-gray-600">
              Loved earning with us? There's more where that came from — explore fresh paid offers
              waiting for you on our platform.
            </p>
            <a
              href={environment.OFFERS_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center justify-center rounded-[30px] bg-[#e2231a] px-6 py-3 text-sm font-semibold text-white shadow-[0_6px_16px_rgba(226,35,26,0.35)] transition-transform active:translate-y-px"
            >
              Join Swittch
            </a>

            <p className="mt-4 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
              Or sign up from your phone
            </p>
            <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
              <a
                href={environment.OFFERS_APP_IOS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 rounded-xl bg-black px-4 py-2 text-white transition-transform active:translate-y-px"
              >
                <AppleIcon sx={{ fontSize: 22 }} />
                <span className="text-left leading-tight">
                  <span className="block text-[9px] text-gray-300">Download on the</span>
                  <span className="block text-sm font-semibold">App Store</span>
                </span>
              </a>
              <a
                href={environment.OFFERS_APP_ANDROID_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 rounded-xl bg-black px-4 py-2 text-white transition-transform active:translate-y-px"
              >
                <AndroidIcon sx={{ fontSize: 22, color: "#3ddc84" }} />
                <span className="text-left leading-tight">
                  <span className="block text-[9px] text-gray-300">Get it on</span>
                  <span className="block text-sm font-semibold">Google Play</span>
                </span>
              </a>
            </div>
          </div>
        </>
      )}
    </RespondentTerminalPage>
  );
};

export default SuccessV2;
